import api from './base';
import { GetListType } from './types/GetListType';

class EventsApi {
  public getEvents = async (companyId: string | null, params?: any) => {
    const response = await api.get(`/events`, {
      params: { ...params, companyId },
    });

    return response.data;
  };
}

export default new EventsApi();
